import {
  CreateOrderRequest,
  CreateOrderResponse,
  GetOrderRequest,
  GetOrderResponse,
  ListOrderRequest,
  ListOrderResponse,
  ORDER_GET,
  ORDER_LIST,
  ORDER_REPAYED,
  ORDER_UPDATE,
  RePayedOrderRequest,
  RePayedOrderResponse,
  UpdateOrderRequest,
  UpdateOrderResponse,
} from "@project/shared-types";

// TasksReques
import { ORDER_CREATE } from "@project/shared-types";
import apiFetchPost from "../apiClient";
export const CreateOrderAPI = async (dataResuest: CreateOrderRequest) => {
  try {
    const response = await apiFetchPost<
      CreateOrderRequest,
      CreateOrderResponse
    >(ORDER_CREATE, dataResuest);
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const GetOrderAPI = async (dataResuest: GetOrderRequest) => {
  try {
    const response = await apiFetchPost<GetOrderRequest, GetOrderResponse>(
      ORDER_GET,
      dataResuest
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const UpdateOrderAPI = async (dataResuest: UpdateOrderRequest) => {
  try {
    const response = await apiFetchPost<
      UpdateOrderRequest,
      UpdateOrderResponse
    >(ORDER_UPDATE, dataResuest);
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const ListOrderAPI = async (dataResuest: ListOrderRequest) => {
  try {
    const response = await apiFetchPost<ListOrderRequest, ListOrderResponse>(
      ORDER_LIST,
      dataResuest
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const RePayedOrderAPI = async (dataResuest: RePayedOrderRequest) => {
  try {
    const response = await apiFetchPost<
      RePayedOrderRequest,
      RePayedOrderResponse
    >(ORDER_REPAYED, dataResuest);
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
